import { render, staticRenderFns } from "./PopupAd.vue?vue&type=template&id=0f62b475&scoped=true&"
import script from "./PopupAd.vue?vue&type=script&lang=js&"
export * from "./PopupAd.vue?vue&type=script&lang=js&"
import style0 from "./PopupAd.vue?vue&type=style&index=0&id=0f62b475&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f62b475",
  null
  
)

export default component.exports